export default "__VITE_ASSET__NCfrThWA__"